import React from 'react';
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardLayout from "../components/CardLayout.js";


export default function Status401 (props) {

  return (
    <CardLayout title="Contenuto riservato">
        <p>
          Accedi per visualizzare questo contenuto
        </p>
        <Button as={Link} to="/login" variant="primary">
          Accedi
        </Button>
    </CardLayout>
  );
}
